import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { jobListingsBySearch } from "../../api/SearchAPI";
import { applyNow, getAppliedJobs } from "../../api/applyNowApi";
import { saveJob, getSavedJobs } from "../../api/savedjobsApi"

function JobSeekerDashboard() {
  const [jobs, setJobs] = useState([]);
  const [filters, setFilters] = useState({
    keyword: "",
    location: "",
    experience_min: "",
    salary_min: "",
    sort_by: "date",
  });

  const appUserId = localStorage.getItem("aUId");
  const token = localStorage.getItem("otoken");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Fetch jobs when filters change
  useEffect(() => {
    const fetchJobs = async () => {
      setLoading(true);
      setError("");
      try {
        const jobData = await jobListingsBySearch(appUserId, token, filters);
        const appliedIds = await getAppliedJobs(appUserId, token);
        const savedIds = await getSavedJobs(appUserId, token);
        const updatedJobs = jobData.jobs.map(job => ({
          ...job,
          applied: appliedIds.includes(job.job_id),
          saved: savedIds.includes(job.job_id),
        }));

      setJobs(updatedJobs);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch jobs");
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, [filters, appUserId, token]);
  const handleApply = async (job_id) => {
          const token = localStorage.getItem("otoken");
          const job_seeker_id = localStorage.getItem("aUId");
          setError("");
          try {
            const res = await applyNow(job_id, job_seeker_id, token);
             setJobs(prev =>
              prev.map(job =>
                job.job_id === job_id ? { ...job, applied: true } : job
              )
            );
           // alert("Application submitted successfully!");
            console.log(res);
          } catch (err) {
              setError(err.response?.data?.error || "Failed to apply!");
            // alert(err.response?.data?.error || "Failed to apply!");
          }
        };

        const handleSaveJob = async (job_id) => {
          const token = localStorage.getItem("otoken");
          const job_seeker_id = localStorage.getItem("aUId");

          try {
            const res = await saveJob(job_id, job_seeker_id, token);

            setJobs(prevJobs =>
              prevJobs.map(job =>
                job.job_id === job_id ? { ...job, saved: true } : job
              )
            );

            alert("Job saved successfully!");
          } catch (err) {
            alert(err.response?.data?.error || "Failed to save job");
          }
        };

  return (
    <div className="content-body">
      <div className="container-fluid mt-3">
        <section className="container my-5">
          <h2 className="mb-4 text-center">Search Jobs with Advanced Filters</h2>
          <form>
            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="keywords">Keywords</label>
                <input
                  type="text"
                  className="form-control"
                  id="keywords"
                  placeholder="E.g., Developer, Designer"
                  name="keyword"
                  value={filters.keyword}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group col-md-4">
                <label htmlFor="location">Location</label>
                <input
                  type="text"
                  className="form-control"
                  id="location"
                  placeholder="City, State, or Zip"
                  name="location"
                  value={filters.location}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group col-md-4">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  placeholder="Company Name"
                  name="company"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-3">
                <label htmlFor="jobType">Job Type</label>
                <select
                  className="form-control"
                  id="jobType"
                  name="job_type"
                  value={filters.job_type || ""}
                  onChange={handleChange}
                >
                  <option value="">Any</option>
                  <option>Full-Time</option>
                  <option>Part-Time</option>
                  <option>Contract</option>
                  <option>Temporary</option>
                  <option>Internship</option>
                </select>
              </div>

              <div className="form-group col-md-3">
                <label htmlFor="jobType">Work Mode</label>
                <select
                  className="form-control"
                  id="workMode"
                  name="work_mode"
                  value={filters.work_mode || ""}
                  onChange={handleChange}
                >
                  <option value="">Any</option>
                  <option>Onsite</option>
                  <option>Remote</option>
                  <option>Hybrid</option>
                </select>
              </div>

              <div className="form-group col-md-3">
                <label htmlFor="experience_min">Experience Min</label>
                <input
                  type="number"
                  className="form-control"
                  id="experience_min"
                  name="experience_min"
                  value={filters.experience_min}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group col-md-3">
                <label htmlFor="salary_min">Salary Min</label>
                <input
                  type="number"
                  className="form-control"
                  id="salary_min"
                  name="salary_min"
                  value={filters.salary_min}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group col-md-3">
                <label htmlFor="sort_by">Sort By</label>
                <select
                  className="form-control"
                  id="sort_by"
                  name="sort_by"
                  value={filters.sort_by}
                  onChange={handleChange}
                >
                  <option value="date">Newest</option>
                  <option value="salary">Salary</option>
                  <option value="relevance">Relevance</option>
                </select>
              </div>
            </div>
          </form>
        </section>

        <section className="container">
          <h2 className="mb-4 text-center">Job Listings</h2>

          {loading && <p className="text-center">Loading jobs...</p>}
          {error && <p className="text-center text-danger">{error}</p>}
          {jobs.length === 0 && !loading && <p className="text-center">No jobs found.</p>}

          <div className="row">
            {jobs.map((job) => (
              <div key={job.id} className="col-md-6 mb-4">
                <div className="card h-100">
                  <div className="card-body">
                    <h5 className="card-title">{job.title}</h5>
                    <h6 className="card-subtitle mb-2 text-muted">
                      Company: {job.company.company_name || "N/A"}
                    </h6>
                    <p className="card-text">
                      Location: {job.job_location} <br />
                      Job Type: {job.job_type} <br />
                      Work Mode: {job.work_mode} <br />
                      Experience: {job.min_experience_required} - {job.max_experience_required} <br />
                      Salary: {job.currency_salary} &nbsp; {job.min_salary} - {job.max_salary} <br />
                      Posted: {new Date(job.created_at).toLocaleDateString()}
                    </p>
                      <div className="d-flex align-items-center">
                        <button className={`btn ${job.applied ? "btn-primary" : "btn-success"} mr-2`}
                          disabled={job.applied}  onClick={() => handleApply(job.job_id)}>
                          {job.applied ? "Applied" : "Apply Now"}
                        </button>
                        <button className= "btn btn-warning mr-5" onClick={() => handleApply(job.job_id)}>
                          View Job
                        </button>                      
                        <button
                            className={`btn ${job.saved ? "btn-secondary" : "btn-outline-secondary"} ms-auto`}
                            disabled={job.saved}
                            onClick={() => handleSaveJob(job.job_id)}
                          >
                            {job.saved ? <i className="fa fa-bookmark"></i> : <i class="fa fa-bookmark-o"></i>}
                        </button>
                      </div>
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default JobSeekerDashboard;
